import { makeStyles } from '@mui/styles';

const promocodesStyles = makeStyles((theme) => {
  return {
    root: {
      minHeight: `calc(100vh - ${
        theme.config.isTopNavbarFixed ? '0px' : '96px'
      })`,
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      paddingTop: theme.config.isTopNavbarFixed ? '96px' : '0px',
      //   backgroundImage: `url(${TransactionsRootBackground()})`,
      //   backgroundSize: 'cover',
      //   backgroundRepeat: 'no-repeat',
      //   backgroundPosition: 'center',
      // backgroundAttachment: 'fixed',
    },
    divTableContainer: {
      width: '95%',
      [theme.breakpoints.up('md')]: {
        width: '70%',
      },
      position: 'relative',
    },
    documentsCard: {
      margin: theme.spacing(1),
      width: '100%',
      position: 'relative',
      background: 'rgba(230,230,230,0.95)',
      color: theme.palette.primary.dark,
    },
    documentFormBoxRoot: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '400px',
      },
    },
    backdrop: {
      zIndex: 1,
      color: theme.palette.primary.dark,
    },
    grow: {
      flexGrow: 1,
    },
  };
});

export default promocodesStyles;
